export const isDevMode = process.env.REACT_APP_ENV === 'development';
export const FACEBOOK_APP_ID = '257778882062116';